import React from 'react';

import SelectUserCustomRequestCer from 'commons/SelectUserCustomRequestCer';

import ArtworkInfo from './components/ArtworkInfo';

const MainContentWrapper = ({
  artworkFormState,
  artwork,
  listUploadedImages,
  setListUploadedImages,
  requestUser,
}) => {
  return (
    <>
      <SelectUserCustomRequestCer
        requestUser={requestUser}
        artworkFormState={artworkFormState}
      />

      <ArtworkInfo
        artwork={artwork}
        artworkFormState={artworkFormState}
        listUploadedImages={listUploadedImages}
        setListUploadedImages={setListUploadedImages}
      />
      {/* <OwnerInfoRequestCer
        ownerName={user?.legal_name}
        yearOfBirth={user?.year_of_birth}
        address={user?.place_of_birth}
      /> */}
    </>
  );
};

export default MainContentWrapper;
